import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { LOGIN } from '../../constants/routes';
import { LOGOUT } from '../../constants/actionTypes';

function LogoutScreen() {
  const dispatch = useDispatch();

  dispatch({
    type: LOGOUT,
  });

  return <Redirect to={LOGIN} />;
}

export default LogoutScreen;
